import bg from '../img/mainbg.png';
import Header from './Header';
import SearchTab from './SearchTab';
import PlayButton from '../img/PlayButton.png';
import Modal from './Modal';
import movie from '../video/movie.mp4';
export default function Banner() {
    return <>
        <div style={{ backgroundImage: `url(${bg})` }} className="bannerWrap">
            <Header />
            <div className='container' >
                <div className='banner_content' >
                    <Modal modalclass="videoPopup" btnclass="bg-transparent border-0 m-auto d-table mb-5 " btntext={<>
                        <div className='playBtn cursor-pointer'>
                            <img src={PlayButton} className="img-fluid" alt="image" />
                        </div></>} >
                        <video controls> 
                            <source src={movie} type="video/mp4" />
                            <source src={movie} type="video/ogg" />
                        </video> 
                    </Modal>  
                    <h2 className='heading lg text-white mb-3 text-center' >Stress-Free Moving & <br></br>
                        Junk Removal, We Move People Forward!</h2>
                    <p>ExquisiteMoves is the nation’s leading full-service moving company, offering customers comprehensive home and business relocation, packing and unpacking, and junk removal services.</p>
                    <SearchTab />
                </div>
            </div>
        </div>
    </>
}

